import Vue from 'vue'
import { makeid, flatten } from '@/helpers'
import { createrow, createparent, referencechildren, setrowdefaults } from '@/row'

const state = Vue.observable({
    prices: window.localStorage.getItem('prices') ? JSON.parse(window.localStorage.getItem('prices')) : [],
    price: null,
    editingReference: ''
});

// getters
const getters = {
    prices: state => state.prices, //all prices
    price: state => state.price,
    editingReference: state => state.editingReference,
    referenceModel: (state) => (row) => {
			let price = state.prices.find(p => p.id === row.price_id)
			let rows = flatten(price.rows)
      let filtered = rows.filter((r) => {
        return r.id === row.link_id;
			})
			return filtered[0]
    },
    flattendRows: (state) => {
      return flatten(state.price.rows);
    },
    priceTotalMode: (state) => {
      return state.price.priceTotalMode || 'COMPUTED'
    },
    totalPrice: (state, getters) => {
      if(getters.priceTotalMode === 'COMPUTED'){
        return getters.totalCostIncMarkup
      }else{
        return state.price.fixedPrice || 0
      }
    },
    totalPriceIncTax: (state, getters) => {
      let tax = 1 + (state.price.tax.rate / 100)
      return getters.totalPrice * tax
    },
    totalCost: (state, getters) => {
			let total = 0
			if(state.price.rows){
				state.price.rows.forEach((row) => {
					total += getters.totalRowCost(row)
				})
			}
      return total
    },
    totalCostIncMarkup: (state, getters) => {
        let markup = 1 + (state.price.markup.rate / 100)
        return getters.totalCost * markup
    },
    totalCostIncTax: (state, getters) => {
         let tax = 1 + (state.price.tax.rate / 100)
         return getters.totalCost * tax
    },
    totalCostIncMarkupIncTax: (state, getters) => {
        let tax = 1 + (state.price.tax.rate / 100)
        return getters.totalCostIncMarkup * tax ;
    },
    totalRowCost: (state, getters) => (row) => {
        if(row.rows && row.rows.length > 0){
          if(row.active){
            let total = getters.childRowsTotal(row)
            return total * row.qty
          }else{
            return 0
          }
        }else{
          if(row.active){
            let rate = row.rate
            if(row.is_reference){
              let refRow = getters.referenceModel(row)
              rate = refRow.rate
            }
            return row.qty * rate
          }else{
            return 0
          }
        }
    },
    childRowsTotal: (state, getters) => (parent) =>{
      let total = 0
      if(parent.rows){
        parent.rows.forEach(row => {
          if(row.rows){
            let childrenTotal = getters.childRowsTotal(row)
            childrenTotal *= row.qty
            total += childrenTotal
          }else{
            let rate = row.rate
            if(row.is_reference){
              let refRow = getters.referenceModel(row)
              rate = refRow.rate
            }
            let rowTotal = row.active ? row.qty * rate : 0
            total += rowTotal
          }
        })
      }
      return total
    },
    totalTimeHours: (state, getters, rootState) => {
				let total = 0
				if(state.price.rows){
					state.price.rows.forEach((row) => {
						if(row.active){
							if(row.rows && row.rows.length > 0){
								total += getters.childRowsHours(row)
							}else{
								let uom = row.uom
								if(row.is_reference){
									let refRow = getters.referenceModel(row)
									uom = refRow.uom
								}
								if (uom.name.toLowerCase() == 'time' && uom.unit.toLowerCase() == 'hours') {
									total += row.qty
								} else if (uom.name.toLowerCase() == 'time' && uom.unit.toLowerCase() == 'days') {
									total += row.qty * rootState.settings.settings.time.hoursperday
								}
							}
						}
					})
				}
        return total
    },
    childRowsHours: (state, getters, rootState) => (parent) =>{
      let total = 0
      parent.rows.forEach(row => {
        if(row.active){
          if(row.rows){
            let childrenTotal = getters.childRowsHours(row)
            childrenTotal *= row.qty
            total += childrenTotal
          }else{
            let uom = row.uom
            if(row.is_reference){
              let refRow = getters.referenceModel(row)
              uom = refRow.uom
            }
            console.log(uom)

            if (uom.name.toLowerCase() == 'time' && uom.unit.toLowerCase() == 'hours') {
              total += row.qty
            } else if (uom.name.toLowerCase() == 'time' && uom.unit.toLowerCase() == 'days') {
              total += row.qty * rootState.settings.settings.time.hoursperday
            }
          }
        }
      })
      return total
    },
    totalTimeDays: (state, getters, rootState) => {
      if (!state.price.rows) return 0
      if (state.price.rows.length == 0) return 0

      return getters.totalTimeHours / rootState.settings.settings.time.hoursperday
    },
    totalCostTime: (state, getters) => {
      let mapped = getters.flattendRows.map(row => {
        if (row.uom === undefined) return 0
        if (Object.keys(row.uom).length === 0) return 0

        if (row.uom.name.toLowerCase() == 'time') {
          return row.active ? row.qty * row.rate : 0
        } else {
          return 0
        }
      });
      return mapped.reduce((a, b) => a + b, 0)
    },
    totalCostMaterials: (state, getters) => {
      let mapped = getters.flattendRows.map(row => {
        if (row.uom === undefined) return 0
        if (Object.keys(row.uom).length === 0) return 0

        if (row.uom.name.toLowerCase() == 'materials') {
          return row.active ? row.qty * row.rate : 0
        } else {
          return 0
        }
      });
      return mapped.reduce((a, b) => a + b, 0)
    },
    margin: (state, getters) => {
        let cost = getters.totalCost
        let price = getters.totalPrice
        let diff = price - cost
        let margin = (diff/price) * 100
        return margin
    },
    profit: (state, getters) => {
      let price = getters.totalPrice
      let cost = getters.totalCost
      return price - cost
    }
};

// mutations
const mutations = {
    ADD_PRICE (state, price) {
      state.prices.push(price);
    },
    UPDATE_PRICE (state, price) {
      state.price.name = price
    },
    DELETE_PRICE (state, idx) {
      state.prices.splice(idx, 1)
    },
    SET_PRICE (state, price) {
      if(price){
        state.price = price
        document.title = price.name + ' – Sort Work'
      }else{
        state.price = null
        document.title = 'Sort Work - Calculate project prices'
      }
    },
    SET_PRICE_TOTAL_MODE(state, mode){
      Vue.set(state.price, 'priceTotalMode', mode)
    },
    SET_PRICE_TOTAL(state, price){
      Vue.set(state.price, 'fixedPrice', price)
    },
    ADD_NEW_ROW_TO_PRICE(state, { idx, row }) {
        state.price.rows.splice(idx, 0, row);
    },
    ADD_ROWS_TO_PRICE(state, rows){
      state.price.rows = state.price.rows.concat(rows)
    },
    REMOVE_ROW_FROM_PRICE(state, idx) {
        state.price.rows.splice(idx, 1);
    },
    DELETE_ROW_FROM_PRICE(state, rowToDelete) {
        //remove row from array

        //if this row is the root of a reference then we need to assign
        //another one as the root
        //let isRoot = rowToDelete.is_reference && !rowToDelete.link_id
        let link_id = rowToDelete.link_id
        let linked_description = rowToDelete.linked_description
        let is_root = rowToDelete.link_id === rowToDelete.id

        const idx = state.price.rows.findIndex(row => row.id === rowToDelete.id)
        state.price.rows.splice(idx, 1);

        //if there is only one more reference row after this one is deleted
        //then make the last row not a reference anymore
        //const row = state.price.rows.findIndex(row => row.id === idx)
        let references = state.price.rows.filter((row) => {
            return row.link_id === link_id
        })

        //we deleted the root so we need to update all the references
        if(is_root){
            Vue.set(references[0], 'linked_description', linked_description)
            references.forEach(reference => {
                Vue.set(reference, 'link_id', references[0].id)
            })
        }


        if(references.length === 1){
            let ref = references[0]

            let description = ref.linked_description + '\r\n' + ref.description
            Vue.set(ref, 'description', description)
            Vue.delete(ref, 'link_id')
            Vue.delete(ref, 'is_reference')
            Vue.delete(ref, 'linked_description')
        }


    },
    DELETE_ROW_FROM_MODEL(state, { rowToDelete, model }) {
        let link_id = rowToDelete.link_id
        let linked_description = rowToDelete.linked_description
        let is_root = rowToDelete.link_id === rowToDelete.id
        let is_reference = rowToDelete.is_reference

        const idx = model.rows.findIndex(row => row.id === rowToDelete.id)
        model.rows.splice(idx, 1);

        if(model.rows.length === 0){
            let r = createrow(model.id)
            Vue.set(model, 'uom', r.uom)
            Vue.set(model, 'rate', r.rate)
            Vue.set(model, 'qty', r.qty)
            Vue.set(model, 'show_description', true)
            Vue.delete(model, 'rows')
        }

        //if there is only one more reference row after this one is deleted
        //then make the last row not a reference anymore
        //const row = model.rows.findIndex(row => row.id === idx)
        if(is_reference){
            let allrows = flatten(state.price.rows)

            let references = allrows.filter((row) => {
                return row.link_id === link_id;
            })

            //we deleted the root so we need to update all the references
            if(is_root){
                Vue.set(references[0], 'linked_description', linked_description)
                references.forEach(reference => {
                    Vue.set(reference, 'link_id', references[0].id)
                })
            }


            if(references.length === 1){
                let ref = references[0]

                let description = ref.linked_description + '\r\n' + ref.description
                Vue.set(ref, 'description', description)
                Vue.delete(ref, 'link_id')
                Vue.delete(ref, 'is_reference')
                Vue.delete(ref, 'linked_description')
            }
        }

    },
    ADD_ROW_TO_MODEL_AT_INDEX(state, payload){
        if(!payload.model.rows){
          Vue.set(payload.model, 'rows', [])
        }
        payload.model.rows.splice(payload.index, 0, payload.row);
    },
    SET_EDITING_REFERENCE(state, idx) {
        state.editingReference = idx
    },
    CONVERT_ROW_TO_INDEPENDENT(state, rowToConvert){
        let link_id = rowToConvert.link_id
        let is_root = rowToConvert.link_id === rowToConvert.id
        let linked_description = ''
        let description = ''
        if(is_root){
            linked_description = rowToConvert.linked_description
            description = rowToConvert.linked_description + ' ' + rowToConvert.description
        }else{
            let refRow = getters.referenceModel(rowToConvert)
            linked_description = refRow.linked_description
            description = linked_description + ' ' + rowToConvert.description
        }

        let rate = rowToConvert.rate

        Vue.delete(rowToConvert, 'link_id');
        Vue.delete(rowToConvert, 'is_reference');
        Vue.delete(rowToConvert, 'linked_description');
        Vue.set(rowToConvert, 'show_description', true);
        Vue.set(rowToConvert, 'description', description);
        Vue.set(rowToConvert, 'rate', rate);

        //if there is only one more reference row after this one is deleted
        //then make the last row not a reference anymore
        //const row = model.rows.findIndex(row => row.id === idx)
        let allrows = flatten(state.price.rows)

        let references = allrows.filter((row) => {
            return row.link_id === link_id;
        })

        //we deleted the root so we need to update all the references
        if(is_root){
            Vue.set(references[0], 'linked_description', linked_description)
            references.forEach(reference => {
                Vue.set(reference, 'link_id', references[0].id)
            })
        }


        if(references.length === 1){
            let ref = references[0]

            let description = ref.linked_description + '\r\n' + ref.description
            Vue.set(ref, 'description', description)
            Vue.set(ref, 'uom', rowToConvert.uom)
            Vue.set(ref, 'rate', rowToConvert.rate)
            Vue.delete(ref, 'link_id')
            Vue.delete(ref, 'is_reference')
            Vue.delete(ref, 'linked_description')
        }
    },
    REFERENCE_ROW_IN_MODEL_AT_INDEX(state, { row, model, index }){
        //first clone the row so we have our new row
        let clone = JSON.parse(JSON.stringify(row))

        //set the clone as a reference
        /*Vue.set(clone, 'is_reference', true)
        Vue.set(clone, 'description', '')
        Vue.set(clone, 'link_id', row.id)
        Vue.delete(clone, 'linked_description')

        //set the row we are referencing as a reference
        Vue.set(row, 'is_reference', true)
        Vue.set(row, 'link_id', row.id) //set the link_id to itself
        if(!row.linked_description){
            Vue.set(row, 'linked_description', row.description)
            Vue.set(row, 'description', '')
        }*/
        referencechildren(row, clone)

        //add the cloned row to the model we passed in
        if(!model.rows){
            Vue.set(model, 'rows', [])
        }

        Vue.set(clone, 'root_id', model.id)

        model.rows.splice(index, 0, clone)
    },
    ADD_PARENT_ROW_TO_MODEL(state, { model, index }){

        //make a new ID for this row
        let parent_id = makeid(4)

        //create the row with blank data
        let parent = createparent(parent_id)

        let row_id = makeid(4)
        let row = createrow(row_id)

        if(!model.root_id){
            model.root_id = model.id
        }

        row.parent_id = parent.id
        row.root_id = model.id
        parent.parent_id = model.id
        parent.root_id = model.id

        //add model as a child
        parent.rows.splice(0, 0, row)

        if(!model.rows){
            Vue.set(model, 'rows', [])
        }

        model.rows.splice(index, 0, parent)

    },
    DUPLICATE_ROW_IN_MODEL_AT_INDEX(state, {row, model, index}){
        let clone = JSON.parse(JSON.stringify(row))
        Vue.set(clone, 'id', makeid(4))
        Vue.set(clone, 'root_id', clone.id)
        model.rows.splice(index, 0, clone)
		},
		SET_ROW_COLOR(state, payload){
			let row = payload.row
			let color = payload.color
			Vue.set(row, 'color', color)
		}
};

// actions
const actions = {
	setRowColor({ commit, dispatch }, payload){
		let row = payload.row
		let color = payload.color
		commit('SET_ROW_COLOR', payload)
		if(row.rows){
			row.rows.forEach(r => {
				let payload = {
					row: r,
					color: color
				}
				dispatch('setRowColor', payload)
			})
		}
	},
	loadDefaultPrices({ commit }){
		if(window.localStorage.getItem('prices')){
			return
		}
		let prices = [
			'Simple-widget-RVO2-2021-03-11.json',
			'Complex-with-references-GYbi-2021-03-11.json',
			'Panels-Pnls-2021-03-11.json',
			'Hardware-Hdwr-2021-03-11.json'
		]

		prices.forEach(p => {
			const req = require(`@/store/prices/${p}`)
			commit('ADD_PRICE', req)
		})

		/*onst p1 = require('@/store/prices/Simple-widget-RVO2-2021-03-11.json');
		const p2 = require('@/store/prices/Complex-with-references-GYbi-2021-03-11.json');
		const p3 = require('@/store/prices/Panels-Pnls-2021-03-11.json');
		const p4 = require('@/store/prices/Hardware-Hdwr-2021-03-11.json');
		commit('ADD_PRICE', p1)
		commit('ADD_PRICE', p2)
		commit('ADD_PRICE', p3)
		commit('ADD_PRICE', p4)*/
	},
	addPrice({ commit }, price) {
			commit('ADD_PRICE', price)
	},
	updatePrice ({ commit }, price) {
			commit('UPDATE_PRICE', price)
	},
	deletePrice ({ commit, state }, id) {
			const idx = state.prices.findIndex(price => price.id === id)
			commit('DELETE_PRICE', idx)
	},
	setPrice({ commit, rootState }, idx) {
		let price = state.prices.find(p => p.id === idx)
		if(price){
			if(!price.tax){
				let tax = rootState.settings.settings.tax
				Vue.set(price, 'tax', tax)
			}
			if(!price.markup){
				let margin = rootState.settings.settings.markup
				Vue.set(price, 'markup', margin)
			}
			if(price.rows){
				setrowdefaults(price.rows)
			}
		}

		commit('SET_PRICE', price)
	},
	clearPrice({ commit }) {
		commit('SET_PRICE', null)
	},
	addRowsToPrice({ commit }, rows) {
		rows.forEach(row => {
			Vue.set(row, 'price_id', state.price.id)
		})

		commit('ADD_ROWS_TO_PRICE', rows)
	},
	addRowToModelAtIndex({ commit }, payload){

			let model = payload.model
			let index = payload.index

			//make a new ID for this row
			let id = makeid(4)

			//create the row with blank data
			let row = createrow(id)

			//if we are adding to the price (so at root level)
			//then don't add root_id etc.
			if(model.id !== state.price.id){
				Vue.set(row, 'parent_id', model.id)
				Vue.set(row, 'root_id', model.root_id)
			}
			Vue.set(row, 'price_id', model.price_id || model.id)

			commit('ADD_ROW_TO_MODEL_AT_INDEX', { row, model, index })

	},
	referenceRow({ commit }, data){
			let model = data.model
			let row = data.row
			let index = data.index

			commit('REFERENCE_ROW_IN_MODEL_AT_INDEX', { row, model, index } )
	},
	addParentRow({ commit }, payload) {
			let model = payload.model
			let index = payload.index

			//make a new ID for this row
			let parent_id = makeid(4)

			//create the row with blank data
			let parent = createparent(parent_id)

			let child_id = makeid(4)
			let child = createrow(child_id)

			//if we are adding to the price (so at root level)
			//then don't add root_id etc.
			if(model.id !== state.price.id){
				Vue.set(parent, 'parent_id', model.id)
				Vue.set(parent, 'root_id', model.root_id || model.id)
			}
			Vue.set(parent, 'price_id', model.price_id || model.id)
			Vue.set(child, 'price_id', model.price_id || model.id)
			Vue.set(child, 'parent_id', parent_id)
			Vue.set(child, 'root_id', parent.root_id || parent_id)

			let payloadChild = {
				row: child,
				model: parent,
				index: 0
			}
			let payloadParent = {
				row: parent,
				model: model,
				index: index
			}
			commit('ADD_ROW_TO_MODEL_AT_INDEX', payloadChild )
			commit('ADD_ROW_TO_MODEL_AT_INDEX', payloadParent )

	},
	addChildToModelAtIndex({ commit }, data){

			let model = data.model
			let index = data.index

			//clone this row to add it as first child
			let row1 = JSON.parse(JSON.stringify(model))
			row1.id = makeid(4) //give the clone a new id

			//create a new row
			let id = makeid(4)
			let row2 = createrow(id)
			row2.id = makeid(4)
			Vue.set(row1, 'price_id', model.price_id || model.id)
			Vue.set(row2, 'price_id', model.price_id || model.id)

			if(!row1.root_id){
					row1.root_id = model.id
			}

			row2.parent_id = model.id
			row2.root_id = model.root_id

			//model is not a parent then make it one
			Vue.set(model, 'rows', [])
			Vue.set(model, 'qty', 1)
			Vue.set(model, 'description', '')
			Vue.delete(model, 'uom')
			Vue.delete(model, 'rate')

			//if we are already a parent then just add
			//a blank row to the end of the list
			//if(model.rows && model.rows.length > 0){
			//    model.rows.splice(index, 0, clone)
			//}

			let row = row1
			commit('ADD_ROW_TO_MODEL_AT_INDEX', { row, model, index })
			row = row2
			commit('ADD_ROW_TO_MODEL_AT_INDEX', { row, model, index })
	},
	addChildToParentModelAtIndex({ commit }, data){
			let model = data.model
			let index = data.index

			let id = makeid(4)
			let row = createrow(id)
			row.id = makeid(4)
			Vue.set(row, 'price_id', model.price_id)

			if(!model.root_id){
					model.root_id = model.id
			}

			row.parent_id = model.id
			row.root_id = model.root_id

			commit('ADD_ROW_TO_MODEL_AT_INDEX', { row, model, index })
	},
	addChildToReferenceModelAtIndex({ commit }, data){

			let model = data.model
			let index = data.index
			console.log('addChildToModelAtIndex', model, index)

			//clone this row to add it as first child
			let row1 = JSON.parse(JSON.stringify(model))

			//create a new row
			let id = makeid(4)
			let row2 = createrow(id)
			row2.id = makeid(4)


			if(!row1.root_id){
					row1.root_id = model.id
			}

			row2.parent_id = model.id
			row2.root_id = model.root_id

			//model is not a parent then make it one
			Vue.set(model, 'rows', [])
			Vue.set(model, 'qty', 1)
			Vue.set(model, 'description', '')
			Vue.delete(model, 'uom')
			Vue.delete(model, 'rate')
			Vue.delete(model, 'is_reference')
			Vue.delete(model, 'link_id')
			Vue.delete(model, 'linked_description')

			//if we are already a parent then just add
			//a blank row to the end of the list
			//if(model.rows && model.rows.length > 0){
			//    model.rows.splice(index, 0, clone)
			//}

			let row = row1
			commit('ADD_ROW_TO_MODEL_AT_INDEX', { row, model, index })
			row = row2
			commit('ADD_ROW_TO_MODEL_AT_INDEX', { row, model, index })

	},
	addParentToModelAtIndex({ commit, dispatch }, payload){
			let model = payload.model
			//let index = payload.index

			//clone this row to add it as first child
			let row = JSON.parse(JSON.stringify(model))
			let row_id = makeid(4)
			Vue.set(row, 'id', row_id)
			Vue.set(row, 'root_id', model.root_id || model.id)
			Vue.set(row, 'parent_id', model.id)

			//model is not a parent so make it one
			Vue.set(model, 'rows', [])
			Vue.set(model, 'qty', 1)
			Vue.set(model, 'description', '')
			Vue.delete(model, 'uom')
			Vue.delete(model, 'rate')

			let payloadRow = {
				row: row,
				model: model,
				index: 0
			}
			commit('ADD_ROW_TO_MODEL_AT_INDEX', payloadRow)

			//make a new ID for this row
			let parent_id = makeid(4)

			//create the row with blank data
			let parent = createparent(parent_id)
			Vue.set(parent, 'root_id', model.root_id || model.id)
			Vue.set(parent, 'parent_id', model.id)

			let payloadParent = {
				row: parent,
				model: model,
				index: 1
			}
			dispatch('addParentRow', payloadParent)
			//commit('ADD_PARENT_ROW_TO_MODEL', { model, index })

	},
	addParentToParentModelAtIndex({ commit }, data){
			let model = data.model
			let index = data.index

			commit('ADD_PARENT_ROW_TO_MODEL', { model, index })
	},
	addParentToReferenceModelAtIndex({ commit }, data){
			let model = data.model
			let index = data.index

			//clone this row to add it as first child
			let row1 = JSON.parse(JSON.stringify(model))

			//create parent row

			if(!row1.root_id){
					row1.root_id = model.id
			}

			//model is not a parent then make it one
			Vue.set(model, 'rows', [])
			Vue.set(model, 'qty', 1)
			Vue.set(model, 'description', '')
			Vue.delete(model, 'uom')
			Vue.delete(model, 'rate')
			Vue.delete(model, 'is_reference')
			Vue.delete(model, 'link_id')
			Vue.delete(model, 'linked_description')

			//if we are already a parent then just add
			//a blank row to the end of the list
			//if(model.rows && model.rows.length > 0){
			//    model.rows.splice(index, 0, clone)
			//}

			let row = row1
			commit('ADD_ROW_TO_MODEL_AT_INDEX', { row, model, index })
			commit('ADD_PARENT_ROW_TO_MODEL', { model, index })
	},
	importRowToModelAtIndex({ commit }, payload){
		console.log('importRowToModelAtIndex')
		let model = payload.model
		//let index = payload.index
		let row = payload.row

		//clone this row to add it as first child
		let row1 = JSON.parse(JSON.stringify(model))
		let row1_id = makeid(4)
		Vue.set(row1, 'id', row1_id)
		Vue.set(row1, 'price_id', model.price_id)
		Vue.set(row1, 'parent_id', model.id)
		Vue.set(row1, 'root_id', model.root_id)

		//clone the row
		let row2 = JSON.parse(JSON.stringify(row))
		let row2_id = makeid(4)
		Vue.set(row, 'id', row2_id)
		Vue.set(row2, 'price_id', model.price_id)
		Vue.set(row2, 'parent_id', model.id)
		Vue.set(row2, 'root_id', model.root_id)

		if(row2.linked_description){
				Vue.set(row2, 'description', row2.linked_description)
		}

		Vue.delete(row2, 'is_reference')
		Vue.delete(row2, 'link_id')
		Vue.delete(row2, 'linked_description')

		//model is not a parent then make it one
		Vue.set(model, 'rows', [])
		Vue.set(model, 'qty', 1)
		Vue.set(model, 'description', '')
		Vue.delete(model, 'uom')
		Vue.delete(model, 'rate')

		//if we are already a parent then just add
		//a blank row to the end of the list
		//if(model.rows && model.rows.length > 0){
		//    model.rows.splice(index, 0, clone)
		//}

		let payloadChild1 = {
			row: row1,
			model: model,
			index: 0
		}
		commit('ADD_ROW_TO_MODEL_AT_INDEX', payloadChild1)

		let payloadChild2 = {
			row: row2,
			model: model,
			index: 1
		}
		commit('ADD_ROW_TO_MODEL_AT_INDEX', payloadChild2)
	},
	importRowToParentModelAtIndex({ commit }, payload) {
		console.log('importRowToParentModelAtIndex')
		let model = payload.model
		let index = payload.index

		//clone the row we want to import and give it a new ID
		let row = JSON.parse(JSON.stringify(payload.row))
		let id = makeid(4)
		Vue.set(row, 'id', id)

		//set the cloned rows price ID to our current price
		Vue.set(row, 'price_id', state.price.id)

		//set the rows parent and root IDs
		if(model.id !== state.price.id){
			Vue.set(row, 'parent_id', model.id)
			Vue.set(row, 'root_id', model.root_id)
		}

		//if we are importing a reference row then we need to save it's
		//description to the linked description
		if(row.linked_description){
			Vue.set(row, 'description', row.linked_description)
		}
		Vue.delete(row, 'is_reference')
		Vue.delete(row, 'link_id')
		Vue.delete(row, 'linked_description')

		commit('ADD_ROW_TO_MODEL_AT_INDEX', { row, model, index })
	},
	importRowToReferenceModelAtIndex({ commit }, data){
		console.log('importRowToReferenceModelAtIndex')
		let model = data.model
		let index = data.index
		console.log('addChildToModelAtIndex', model, index)

		//clone this row to add it as first child
		let row1 = JSON.parse(JSON.stringify(model))

		//clone the row
		let row2 = JSON.parse(JSON.stringify(data.row))

		if(row2.linked_description){
				Vue.set(row2, 'description', row2.linked_description)
		}
		Vue.delete(row2, 'is_reference')
		Vue.delete(row2, 'link_id')
		Vue.delete(row2, 'linked_description')


		if(!row1.root_id){
				row1.root_id = model.id
		}

		Vue.set(row2, 'price_id', model.price_id)
		Vue.set(row2, 'parent_id', model.id)
		Vue.set(row2, 'root_id', model.root_id)

		//model is not a parent then make it one
		Vue.set(model, 'rows', [])
		Vue.set(model, 'qty', 1)
		Vue.set(model, 'description', '')
		Vue.delete(model, 'uom')
		Vue.delete(model, 'rate')
		Vue.delete(model, 'is_reference')
		Vue.delete(model, 'link_id')
		Vue.delete(model, 'linked_description')

		//if we are already a parent then just add
		//a blank row to the end of the list
		//if(model.rows && model.rows.length > 0){
		//    model.rows.splice(index, 0, clone)
		//}

		let row = row1
		commit('ADD_ROW_TO_MODEL_AT_INDEX', { row, model, index })
		row = row2
		commit('ADD_ROW_TO_MODEL_AT_INDEX', { row, model, index })
	},
	referenceChildToModelAtIndex({ commit }, data){

			let model = data.model
			let index = data.index

			//clone this row to add it as first child
			let row1 = JSON.parse(JSON.stringify(model))

			//clone the row we want to use as a reference
			let row2 = JSON.parse(JSON.stringify(data.row))
			referencechildren(data.row, row2)
			Vue.set(row2, 'root_id', model.id)
			Vue.set(row2, 'price_id', model.price_id)

			if(!row1.root_id){
					Vue.set(row1, 'root_id', model.id)
			}

			//model is not a parent then make it one
			Vue.set(model, 'id', makeid(4))
			Vue.set(model, 'rows', [])
			Vue.set(model, 'qty', 1)
			Vue.set(model, 'description', '')
			Vue.delete(model, 'uom')
			Vue.delete(model, 'rate')

			let row = row1
			commit('ADD_ROW_TO_MODEL_AT_INDEX', { row, model, index })
			row = row2
			commit('ADD_ROW_TO_MODEL_AT_INDEX', { row, model, index })
	},
	referenceChildToParentModelAtIndex({ commit }, payload) {
			console.log('referenceChildToParentModelAtIndex', payload)
			let model = payload.model
			let index = payload.index

			//clone the row we want to use as a reference
			let row = JSON.parse(JSON.stringify(payload.row))
			Vue.set(row, 'root_id', model.id)
			Vue.set(row, 'price_id', model.price_id || model.id)
			Vue.set(row, 'qty', 1)
			Vue.delete(row, 'rate');
			Vue.delete(row, 'uom');
			referencechildren(payload.row, row)

			commit('ADD_ROW_TO_MODEL_AT_INDEX', { row, model, index })

	},
	duplicateRow({ commit }, data) {

			let idx = data.index

			//clone the row
			let row = JSON.parse(JSON.stringify(data.row));

			//make a new id for this new row
			row.id = makeid(4);

			commit('ADD_NEW_ROW_TO_PRICE', { idx, row })
	},
	//TODO: remove
	//UNUSED
	addNewChild({ commit }, data) {
			//make a new ID for this row
			let id = makeid(4)

			//create the row with blank data
			let row = createparent(id)

			//add model as a child
			row.rows.splice(0, 0, data.model)

			let idx = data.index

			// commit('ADD_NEW_ROW_TO_PRICE', { idx, row })
			//commit('ADD_NEW_ROW_TO_PARENT', { mode, row, idx })

			//remove row from array
			commit('REMOVE_ROW_FROM_PRICE', idx )

			//add the row to our price
			commit('ADD_NEW_ROW_TO_PRICE', { idx, row } )

	},
	deleteRow({ commit }, row) {
			commit('DELETE_ROW_FROM_PRICE', row )
	},
	deleteRowFromModel({ commit }, data) {
			let rowToDelete = data.row
			let model = data.model

			commit('DELETE_ROW_FROM_MODEL', { rowToDelete, model } )
	},
	setEditingReference({ commit }, idx) {
			commit('SET_EDITING_REFERENCE', idx )
	},
	convertRowToIndependent({ commit }, row) {
			let rowToConvert = row
			commit('CONVERT_ROW_TO_INDEPENDENT', rowToConvert)
	},
	duplicateRowInModelAtIndex({ commit }, data) {
			let model = data.model
			let row = data.row
			let index = data.index

			commit('DUPLICATE_ROW_IN_MODEL_AT_INDEX', { row, model, index } )
	}
};

const vm = new Vue();
vm.$watch(
  () => state,
  () => {
    window.localStorage.setItem('prices', JSON.stringify(state.prices))
  },
  {
    deep: true
  }
);

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
